import fitty from 'fitty';


document.addEventListener('DOMContentLoaded', () => {
    var fitties = fitty('.fit', {
        minSize: 30,
        maxSize: 90
    });
});


// WEBPACK FOOTER //
// ./assets/src/js/modules/fitty.js